export enum PapelEstabelecimentoEnum {
    DONO = "DONO",
    EDITOR = "EDITOR"
}